
export function must<T>(obj: unknown, type: abstract new (...args: any[]) => T): T {
    if (!(obj instanceof type)) {
        throw new Error(`${obj} is not an instance of ${type.name}`);
    }

    return obj;
}

export function mustProperty<T extends object, K extends keyof T>(obj: T, key: K): T[K] {
    if (!(key in obj)) {
        throw new Error(`cannot find property ${String(key)} in object ${obj}`);
    }

    return obj[key];
}

export function mustError(error: unknown): Error {
    if (error instanceof Error) {
        return error;
    }

    if (typeof error === "string") {
        return new Error(error);
    }

    return new Error(String(error));
}

export function mustQuerySelector<E extends Element = HTMLElement>(element: Element, selectors: string): E {
    const elt = element.querySelector<E>(selectors);

    if (elt === null) {
        throw new Error(`cannot query ${selectors} in ${element.className}`);
    }

    return elt;
}

export function mustClosest<E extends Element = HTMLElement>(element: Element, selectors: string): E {
    const elt = element.closest<E>(selectors);

    if (elt === null) {
        throw new Error(`cannot find closest ${selectors} in ${element.className}`);
    }

    return elt;
}

export function mustDataset(element: HTMLElement, name: string): string {
    const value: string | undefined = element.dataset[name];

    if (value === undefined) {
        throw new Error(`cannot find ${name} in dataset of HTMLElement ${element}`);
    }

    return value;
}

export function mustMap<K, V>(map: Map<K, V>, key: K): V {
    const value: V | undefined = map.get(key);

    if (value === undefined) {
        throw new Error(`map does not contain key ${key}`);
    }

    return value;
}